import { jsx as _jsx } from "react/jsx-runtime";
import { ShowEveryXBusinessDays } from './ShowEveryXBusinessDays';
import { useLocalStorageState } from '../hooks/useLocalStorageState';
import { addQuarters, startOfQuarter, differenceInBusinessDays, } from 'date-fns';
/**
 * Component that will show its children every X business quarters.
 */
export const ShowEveryXQuarters = ({ children, quartersBetweenRequests, quartersBetweenDismiss, }) => {
    const [lastSent] = useLocalStorageState('lastCsatSent', undefined);
    const [lastDismiss] = useLocalStorageState('lastCsatDismiss', undefined);
    const daysToNextQuarter = (lastDate, quarters) => {
        const nextQuarter = startOfQuarter(addQuarters(lastDate, quarters));
        return differenceInBusinessDays(nextQuarter, lastDate);
    };
    return (_jsx(ShowEveryXBusinessDays, Object.assign({ businessDaysBetweenDismiss: daysToNextQuarter(lastDismiss, quartersBetweenDismiss), businessDaysBetweenRequests: daysToNextQuarter(lastSent, quartersBetweenRequests) }, { children: children })));
};
